var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNokia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m248.67,46.1v67.79h10.17V46.1h-10.17Zm-108.62-1.16c-19.81,0-35.17,14.42-35.17,35.05s15.37,35.05,35.17,35.05c19.81,0,35.2-13.49,35.17-35.05-.03-19.55-15.37-35.05-35.17-35.05Zm25.03,35.05c0,15.28-11.2,25.4-25.03,25.4s-25.03-10.12-25.03-25.4,11.2-25.4,25.03-25.4,25.03,10.4,25.03,25.4ZM36.62,43.91v69.99h10.38v-46.25l53.92,48.45v-14.51L36.62,43.91Zm146.26,36.09l37.73,33.9h15.13l-37.79-33.9,37.79-33.9h-15.13l-37.73,33.9Zm160.51,33.9h-11.18l-8.18-15.01h-37.04l-8.18,15.01h-11.18l13.54-25.02h37.54l-18.72-34.77,5.52-10.19h0s0,0,0,0l37.88,69.99Z",
    fill: "#005aff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNokia);
export default __webpack_public_path__ + "static/media/logo_nokia.e1d70329437ac25081da4d9bf8c46a1a.svg";
export { ForwardRef as ReactComponent };